export const MANAGER_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Tele Sales', href: '/telesales', icon: 'cilPhone' },
  { slug: 'link', name: 'Order Form', href: '/orderform', icon: 'cilPencil' },
  { slug: 'link', name: 'Field Sales Form', href: '/fieldsalesform', icon: 'cilUserFollow', organisationIds: [1, 4] },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },

  { slug: 'title', name: 'CRM & Calls' },
  { slug: 'link', name: 'Call Queue', href: '/callqueue', icon: 'cilCallOutgoing' },
  { slug: 'link', name: 'Call Summary', href: '/callsummary', icon: 'cilChartBar' },
  { slug: 'link', name: 'Graded Follow Ups', href: '/grade_followups', icon: 'cilStar' },
  { slug: 'link', name: 'Field Visits', href: '/fieldvisits', icon: 'cilLocationPin', organisationIds: [1, 4] },
  // {
  //   slug: 'dropdown',
  //   name: 'Follow Ups',
  //   icon: 'cilTask',
  //   elements: [
  //     { slug: 'link', name: 'New Follow Ups', href: '/followup', icon: 'cilTask' },
  //     { slug: 'link', name: 'Customer Follow Ups', href: '/customer_followups', icon: 'cilCommentSquare' },
  //     { slug: 'link', name: 'Grade Followups', href: '/grade_followups', icon: 'cilStar' },
  //   ],
  // },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Lead Conversions', href: '/lead-conversions', icon: 'cilFunnel' },
  { slug: 'link', name: 'Stock Updates', href: '/stock', icon: 'cilInventory' },

  { slug: 'title', name: 'Reports' },
  { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
  { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
